import * as React from 'react';
export default function useMergedConfig(propConfig, templateConfig) {
  return React.useMemo(() => {
    const support = !!propConfig;
    return [support, Object.assign(Object.assign({}, templateConfig), support && typeof propConfig === 'object' ? propConfig : null)];
  }, [propConfig]);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/typography/hooks/useMergedConfig.js
// module id = 1979
// module chunks = 0